import { Component } from '@angular/core';
import { EmployeeDashboardService } from './services/employee-dashboard.service';

@Component({
    selector: 'app-employee-dashboard',
    templateUrl: './employee-dashboard.component.html',
    styleUrls: ['./employee-dashboard.component.css'],
    standalone: false
})
export class EmployeeDashboardComponent {

   counts$ = this.dashboardService.counts$;
   showSidebar: boolean = false;
   // ✅ Default tab
  activeTab: 'approvals' | 'team' | 'metrics' | 'work' | 'portal' = 'approvals';
  empData: any = JSON.parse(localStorage.getItem('empDataFromParent') || '{}');

  constructor(private dashboardService: EmployeeDashboardService) {}

  ngOnInit(): void {
    // this.dashboardService.loadDashboard();
  }

  toggle() {
    this.showSidebar = !this.showSidebar;
  }

  setTab(tab: typeof this.activeTab) {
    this.activeTab = tab;
  }

}
